// extracted by mini-css-extract-plugin
module.exports = {"odds":"Odds__odds__3fqFJ","outcome":"Odds__outcome__23vhV","type":"Odds__type__2-l6M","hot":"Odds__hot__3MCtL"};